import metrix from "./metrix-lib";
import { isDevMod } from "../utils";

class Metrix {
  static _instance: Metrix;
  static _metrix: any;

  static initialize = (options: { uniqueDeviceId: string }): void => {
    if (Metrix._instance === undefined) Metrix._instance = new Metrix();
    if (Metrix._metrix !== undefined) return;
    Metrix._metrix = metrix.initialize({
      appId: process.env.REACT_APP_METRIX_APPID,
      uniqueDeviceId: options.uniqueDeviceId
    });
  };

  static sendEvent = (slug: string, attributes ?: { [key in string]: unknown }): void => {
    if (isDevMod) return;
    if (attributes !== undefined) Metrix._metrix.sendEvent(slug, attributes);
    Metrix._metrix.sendEvent(slug);
  };

}

export default Metrix;
